export const PLAYER_COLOR_INITIAL_NAME_MAPPING = {
    blue: 'Синий',
    dark_green: 'Темно-зеленый',
    purple: 'Фиолетовый',
    yellow: 'Желтый',
    grey: 'Серый',
    red: 'Красный'
};